// Per-tab session identity for user_events / request telemetry.
// sessionStorage is per tab and survives reloads, so: reload = same session,
// new tab = new session. Falls back to an in-memory id when storage throws.
const ID_KEY = "notesai.session_id";
const STARTED_KEY = "notesai.session_started_at";

let memoryId = null;
let memoryStartedAt = null;

function uuid() {
  try {
    if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") return crypto.randomUUID();
  } catch (_) { /* fall through */ }
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

function readItem(key) {
  try { return window.sessionStorage.getItem(key); } catch (_) { return null; }
}

function writeItem(key, value) {
  try { window.sessionStorage.setItem(key, value); } catch (_) { /* ignore */ }
}

export function getSessionId() {
  const stored = readItem(ID_KEY);
  if (stored) return stored;
  if (!memoryId) {
    memoryId = uuid();
    memoryStartedAt = new Date().toISOString();
  }
  writeItem(ID_KEY, memoryId);
  writeItem(STARTED_KEY, memoryStartedAt);
  return memoryId;
}

export function getSessionStartedAt() {
  getSessionId();
  return readItem(STARTED_KEY) || memoryStartedAt || new Date().toISOString();
}

export function _resetSessionForTests() {
  memoryId = null;
  memoryStartedAt = null;
  try {
    window.sessionStorage.removeItem(ID_KEY);
    window.sessionStorage.removeItem(STARTED_KEY);
  } catch (_) { /* ignore */ }
}
